import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { pageTitle } from "@/components/document-title";
import { SchedulerPage } from "@/features/scheduler/pages/scheduler-page";
import { schedulerFilterSchema } from "@/features/scheduler/schemas/scheduler-filter.schema";

export const Route = createFileRoute(
	"/_authenticated/admin/vehicles/scheduler"
)({
	head: () => pageTitle("Scheduler"),
	component: SchedulerPage,
	validateSearch: zodValidator(schedulerFilterSchema),
});
